import { Component, Input } from '@angular/core';

@Component({
    selector: 'salary-average',
    styles: [` .average { font-size: 42px; margin-top: -220px } `],
    template: require('./salary-average.component.pug')
})
export class SalaryAverageComponent {
    @Input() averagePerHour: number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/salaries/salary-average/salary-average.component.ts